import Routes from "@/routes";
import { useClient } from "@/hooks/useClient.ts";
import Loading from "@/pages/Loading.tsx";
import { Toaster } from "@/components/ui/sonner.tsx";
import { useEffect, useState } from "react";
import {
  checkAuthenticationStatus,
  login,
} from "@/api/common/interceptors/authenticationInterceptor.ts";
import { clearAuthCookie, getAuthCookie } from "@/lib/utils.ts";
import { changeClient } from "@/api/authentication/changeClient.ts";

function App() {
  const [loading, setLoading] = useState(true);
  const client = useClient();

  useEffect(() => {
    const asyncEffect = async () => {
      const tempToken = getAuthCookie();
      if (tempToken) {
        try {
          const result = await changeClient(tempToken);
          if (result.data.access_token) {
            await login({
              accessToken: result.data.access_token,
              refreshToken: result.data.refresh_token,
            });
            clearAuthCookie();
          }
        } catch (e: unknown) {
          /* empty */
        }
      }
      await checkAuthenticationStatus();
      setLoading(false);
    };
    asyncEffect();
  }, []);

  if (!client || loading) {
    return <Loading />;
  }
  return (
    <>
      <Routes />
      <Toaster />
    </>
  );
}

export default App;
